import * as Yup from "yup"

import { Button } from "@atoms"

import { Dialog } from "@molecules"
import GenericForm from "@molecules/Form/GenericForm/GenericForm"
import { MutationErrorBase } from "@molecules/Form/GenericForm/GenericForm.types"
import Input from "@molecules/Form/inputs/Input/Input"

import styles from "./RenameFileDialog.module.scss"
import type { RenameFileDialogProps, RenameFileFormFields } from "./RenameFileDialog.types"

const formSchema: Yup.ObjectSchema<RenameFileFormFields> = Yup.object().shape({
    upload_filename: Yup.string().trim().required("Filename is required"),
})

export default function RenameFileDialog(props: RenameFileDialogProps) {
    const { attachment, endpointBase, isOpen, onOpenChange, onSuccess } = props

    return (
        <Dialog.Root isOpen={isOpen} onOpenChange={onOpenChange} mode="dialog" variant="default">
            <Dialog.Content>
                <GenericForm<RenameFileFormFields, Attachment, MutationErrorBase, RenameFileFormFields>
                    formConfig={{ defaultValues: { upload_filename: attachment.upload_filename } }}
                    formValidationSchema={formSchema}
                    mutationConfig={{
                        endpoint: `${endpointBase}${attachment.id}/`,
                        method: "PATCH",
                        genericErrorMessage: "Could not rename file",
                    }}
                    onMutationSuccess={({ formValues }) => {
                        onSuccess(attachment.id, formValues.upload_filename)
                    }}
                >
                    {({ isPending }) => (
                        <>
                            <Dialog.Header.Root>
                                <Dialog.Header.Title title="Rename file" />
                                <Dialog.Header.CloseButton />
                            </Dialog.Header.Root>
                            <Dialog.Body className={styles.dialogBody}>
                                <Input name="upload_filename" label="Filename" size="md" isControlled={true} />
                            </Dialog.Body>
                            <Dialog.Footer.Root>
                                <Button variant="ghost" size="lg" type="button" onClick={() => onOpenChange(false)}>
                                    Cancel
                                </Button>
                                <Button variant="solid" size="lg" type="submit" isProcessing={isPending}>
                                    Save
                                </Button>
                            </Dialog.Footer.Root>
                        </>
                    )}
                </GenericForm>
            </Dialog.Content>
        </Dialog.Root>
    )
}
